
import { SVGProps } from 'react';
const SvgArrowUpRight16 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 16 16"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M12.027 4.38a.746.746 0 0 0-.694-.463H4.667a.75.75 0 1 0 0 1.5h4.856l-5.387 5.386a.75.75 0 1 0 1.061 1.06l5.386-5.386v4.856a.75.75 0 0 0 1.5 0V4.667a.747.747 0 0 0-.056-.287Z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgArrowUpRight16;
